/**
 * Lệnh Bot — sidebar group config (entry point của folder navigation/lenh-bot).
 *
 * Public exports:
 *   - LENH_BOT_BASE_PATH, LENH_BOT_GROUP_ID, LENH_BOT_MENU_ITEM_ID, LENH_BOT_*_LABEL
 *   - LENH_BOT_SCANBM_ROUTE_NAME / ITEM_ID / PATH
 *   - SHARE_TKQC_ROUTE_NAME / ITEM_ID / PATH (re-export từ ./shareTkqc)
 *   - LENH_BOT_MENU_GROUP — group config render trong AdminLayout sidebar
 *
 * Toàn bộ tham chiếu prefix cũ `/admin/tac-vu-tkqc` đã được loại bỏ.
 */
import {
  SHARE_TKQC_ROUTE_NAME,
  SHARE_TKQC_ITEM_ID,
  SHARE_TKQC_LABEL,
  SHARE_TKQC_TITLE,
} from './shareTkqc'
import {
  SET_LIMIT_ROUTE_NAME,
  SET_LIMIT_ITEM_ID,
  SET_LIMIT_LABEL,
} from './setLimit'
import {
  REMOVE_LIMIT_ROUTE_NAME,
  REMOVE_LIMIT_ITEM_ID,
  REMOVE_LIMIT_LABEL,
} from './removeLimit'
import {
  RENAME_TKQC_ROUTE_NAME,
  RENAME_TKQC_ITEM_ID,
  RENAME_TKQC_LABEL,
} from './renameTkqc'
import {
  RENAME_PAGE_ROUTE_NAME,
  RENAME_PAGE_ITEM_ID,
  RENAME_PAGE_LABEL,
} from './renamePage'
import {
  SHARE_PIXEL_ROUTE_NAME,
  SHARE_PIXEL_ITEM_ID,
  SHARE_PIXEL_LABEL,
  SHARE_PIXEL_TITLE,
} from './sharePixel'
import {
  CREATE_CATALOGUE_ROUTE_NAME,
  CREATE_CATALOGUE_ITEM_ID,
  CREATE_CATALOGUE_LABEL,
  CREATE_CATALOGUE_TITLE,
} from './createCatalogue'

export const LENH_BOT_BASE_PATH = '/admin/lenh-bot'
export const LENH_BOT_GROUP_ID = 'lenh-bot'
export const LENH_BOT_MENU_ITEM_ID = 'lenh-bot'
export const LENH_BOT_SIDEBAR_LABEL = 'Lệnh Bot'
export const LENH_BOT_SECTION_LABEL = 'LỆNH BOT'

// Scan BM
export const LENH_BOT_SCANBM_ROUTE_NAME = 'LenhBotScanBm'
export const LENH_BOT_SCANBM_ITEM_ID = 'lenh-bot-scanbm'
export const LENH_BOT_SCANBM_PATH = `${LENH_BOT_BASE_PATH}/scanbm`

// Check TKQC
export const LENH_BOT_CHECKTKQC_ROUTE_NAME = 'LenhBotCheckTkqc'
export const LENH_BOT_CHECKTKQC_ITEM_ID = 'lenh-bot-checktkqc'
export const LENH_BOT_CHECKTKQC_PATH = `${LENH_BOT_BASE_PATH}/check-tkqc`

// Tạm ẩn các lệnh placeholder — bật lại: uncomment block + thêm `...PLACEHOLDER_ITEMS` vào `items` bên dưới
// const PLACEHOLDER_ITEMS = [
//   { id: 'lb-thu-hoi-tkqc', label: 'Thu hồi TKQC', disabled: true },
//   { id: 'lb-scan-bm', label: 'Scan BM', disabled: true },
//   { id: 'lb-tao-desk', label: 'Tạo Desk', disabled: true },
//   { id: 'lb-replace-tkqc', label: 'Replace TKQC', disabled: true },
//   { id: 'lb-rename-tkqc', label: 'Rename TKQC', disabled: true },
//   { id: 'lb-share-page', label: 'Share Page', disabled: true },
//   { id: 'lb-thu-hoi-page', label: 'Thu hồi Page', disabled: true },
//   { id: 'lb-rename-page', label: 'Rename Page', disabled: true },
//   { id: 'lb-share-pixel', label: 'Cấu hình Share Pixel', disabled: true }, // đã bật trong LENH_BOT_MENU_GROUP
//   { id: 'lb-set-limit', label: 'Set Limit', disabled: true },
//   { id: 'lb-remove-limit', label: 'Remove Limit', disabled: true },
//   { id: 'lb-tao-catalogue', label: 'Tạo Catalogue', disabled: true },
//   { id: 'lb-invite-bm', label: 'Invite BM', disabled: true },
//   { id: 'lb-lich-su', label: 'Lịch sử', disabled: true },
//   { id: 'lb-huong-dan', label: 'Hướng dẫn', disabled: true }
// ]

// Share TKQC (re-export cho convenience + đường dẫn URL)
export { SHARE_TKQC_ROUTE_NAME, SHARE_TKQC_ITEM_ID, SHARE_TKQC_LABEL, SHARE_TKQC_TITLE }
export const SHARE_TKQC_PATH = `${LENH_BOT_BASE_PATH}/share-tkqc`

// Share Page
export const SHARE_PAGE_ROUTE_NAME = 'SharePageConfig'
export const SHARE_PAGE_ITEM_ID = 'lenh-bot-share-page'
export const SHARE_PAGE_PATH = `${LENH_BOT_BASE_PATH}/share-page`

// Revoke Page
export const REVOKE_PAGE_ROUTE_NAME = 'RevokePageConfig'
export const REVOKE_PAGE_ITEM_ID = 'lenh-bot-revoke-page'
export const REVOKE_PAGE_PATH = `${LENH_BOT_BASE_PATH}/revoke-page`

// Set Limit
export { SET_LIMIT_ROUTE_NAME, SET_LIMIT_ITEM_ID, SET_LIMIT_LABEL }
export const SET_LIMIT_PATH = `${LENH_BOT_BASE_PATH}/set-limit`

// Remove Limit
export { REMOVE_LIMIT_ROUTE_NAME, REMOVE_LIMIT_ITEM_ID, REMOVE_LIMIT_LABEL }
export const REMOVE_LIMIT_PATH = `${LENH_BOT_BASE_PATH}/remove-limit`

// Rename TKQC
export { RENAME_TKQC_ROUTE_NAME, RENAME_TKQC_ITEM_ID, RENAME_TKQC_LABEL }
export const RENAME_TKQC_PATH = `${LENH_BOT_BASE_PATH}/rename-tkqc`

// Rename Page
export { RENAME_PAGE_ROUTE_NAME, RENAME_PAGE_ITEM_ID, RENAME_PAGE_LABEL }
export const RENAME_PAGE_PATH = `${LENH_BOT_BASE_PATH}/rename-page`
// Share Pixel (/sharepixel)
export { SHARE_PIXEL_ROUTE_NAME, SHARE_PIXEL_ITEM_ID, SHARE_PIXEL_LABEL, SHARE_PIXEL_TITLE }
export const SHARE_PIXEL_PATH = `${LENH_BOT_BASE_PATH}/share-pixel`

// Create Catalogue (/createcatalogue)
export {
  CREATE_CATALOGUE_ROUTE_NAME,
  CREATE_CATALOGUE_ITEM_ID,
  CREATE_CATALOGUE_LABEL,
  CREATE_CATALOGUE_TITLE,
}
export const CREATE_CATALOGUE_PATH = `${LENH_BOT_BASE_PATH}/create-catalogue`

export const LENH_BOT_MENU_GROUP = {
  id: LENH_BOT_MENU_ITEM_ID,
  sectionLabel: LENH_BOT_SECTION_LABEL,
  label: LENH_BOT_SIDEBAR_LABEL,
  icon: 'bot',
  permission: 'view-ad-accounts',
  /** Every child row shows the small chevron like index.html lenhBotCmds */
  subitemChevron: true,
  items: [
    {
      id: SHARE_TKQC_ITEM_ID,
      label: SHARE_TKQC_LABEL,
      route: SHARE_TKQC_PATH,
      permission: 'view-ad-accounts'
    },
    {
      id: LENH_BOT_SCANBM_ITEM_ID,
      label: 'Scan BM',
      icon: 'scan-search',
      route: LENH_BOT_SCANBM_PATH,
      docArrow: true,
      permission: 'view-ad-accounts'
    },
    {
      id: LENH_BOT_CHECKTKQC_ITEM_ID,
      label: 'Check TKQC',
      icon: 'search-check',
      route: LENH_BOT_CHECKTKQC_PATH,
      docArrow: true,
      permission: 'view-ad-accounts'
    },
    {
      id: RENAME_TKQC_ITEM_ID,
      label: RENAME_TKQC_LABEL,
      route: RENAME_TKQC_PATH,
      docArrow: true,
      permission: 'view-ad-accounts'
    },
    {
      id: SHARE_PAGE_ITEM_ID,
      label: 'Share Page',
      route: SHARE_PAGE_PATH,
      permission: 'view-ad-accounts'
    },
    {
      id: REVOKE_PAGE_ITEM_ID,
      label: 'Thu hồi Page',
      route: REVOKE_PAGE_PATH,
      permission: 'view-ad-accounts'
    },
    {
      id: RENAME_PAGE_ITEM_ID,
      label: RENAME_PAGE_LABEL,
      route: RENAME_PAGE_PATH,
      docArrow: true,
      permission: 'view-ad-accounts'
    },
    {
      id: SHARE_PIXEL_ITEM_ID,
      label: SHARE_PIXEL_LABEL,
      route: SHARE_PIXEL_PATH,
      permission: 'view-ad-accounts'
    },
    {
      id: SET_LIMIT_ITEM_ID,
      label: SET_LIMIT_LABEL,
      route: SET_LIMIT_PATH,
      docArrow: true,
      permission: 'view-ad-accounts'
    },
    {
      id: REMOVE_LIMIT_ITEM_ID,
      label: REMOVE_LIMIT_LABEL,
      route: REMOVE_LIMIT_PATH,
      docArrow: true,
      permission: 'view-ad-accounts'
    },
    {
      id: CREATE_CATALOGUE_ITEM_ID,
      label: CREATE_CATALOGUE_LABEL,
      route: CREATE_CATALOGUE_PATH,
      permission: 'view-ad-accounts'
    }
  ]
}
